import React from 'react';
import { CheckupRequestInfo, ValidatedLandingPageDefinition } from '@companion-professional/dctypes';
import { StdLanderBase } from './StdLanderBase';

interface StdLanderPageProps {
  defn: ValidatedLandingPageDefinition;
  checkupRequest: CheckupRequestInfo;
  page: number;
}

export const StdLanderPage = ({ defn, checkupRequest, page }: StdLanderPageProps) => (
  <StdLanderBase
    pageKind="std_lander"
    defn={defn}
    checkupRequest={checkupRequest}
    page={page}
    media={<img src={defn.img_url} alt="Taking video of your dog" />}
  />
);
